import { API_URL } from '../../utils/config';
import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

import  DictListwy from '../DictListwy';

var AddZlecenie = React.createClass({

	getInitialState: function() {

		this.getDictListwy();
		this.suggestTimeout = null;
		return {
			suggestions: [],
			activeSuggestField: null,
			addObject: {
				id: '',
				cena: 0.00,
				grubosc: '',
				hdf: false,
				kosztUslugi: '',
				lustro: false,
				numerListwy: '',
				numerPass: '',
				operator: '',
				punktSprzedazy: '',
				szerokosc: '',
				szklo: 'NIE',
				uwagi: '',
				wysokosc: '',
				zawieszka: false,
				dataZlozenia: '',
				imie: '',
				nazwisko: '',
				telefon: '',
				email: '',
				nip: '',
				czyZrealizowane: '',
				zaliczka: '',
				pozostalaDoplata: '',
				dataOdbioru: '',
				czyPass: false,
				szlif: false,
				faza: false,
				krosno: false,
				folia: false,
				iloscSztuk: 1,
			},
			dictListwa:{
				id: '',
	      numerListwy: '',
	      cenaZaMb: 0.00
			},
			dataDictListwy: null
		}
    },

	render: function() {

		return (
			<Modal show={this.props.parent.state.showAddModal}>
				<Modal.Header>
					<Modal.Title>Dodaj Zlecenie</Modal.Title>
				</Modal.Header>
				<Modal.Body>
						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Imię: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Imię"
								value={this.state.addObject.imie}
								onChange={this.onAddZlecenieImieChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Nazwisko: </ControlLabel>
							</div>
							<div className="col-sm-8" style={{position:'relative'}}>
							<FormControl
								type="text"
								placeholder="Nazwisko"
								value={this.state.addObject.nazwisko}
								onChange={this.onAddZlecenieNazwiskoChange}
								onBlur={this.hideSuggestions} />
							{this.renderSuggestions('nazwisko')}
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Telefon: </ControlLabel>
							</div>
							<div className="col-sm-8" style={{position:'relative'}}>
							<FormControl
								type="text"
								placeholder="Telefon"
								value={this.state.addObject.telefon}
								onChange={this.onAddZlecenieTelefonChange}
								onBlur={this.hideSuggestions} />
							{this.renderSuggestions('telefon')}
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Email: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Email"
								value={this.state.addObject.email}
								onChange={this.onAddZlecenieEmailChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>NIP: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="NIP"
								value={this.state.addObject.nip}
								onChange={this.onAddZlecenieNipChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Numer Listwy: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Numer Listwy"
									value={this.state.addObject.numerListwy}
									onChange={this.onAddZlecenieNrListwyChange} />
									<ControlLabel>Cena za mb: {this.dictListwa ? (this.dictListwa.cenaZaMb ? this.dictListwa.cenaZaMb + ' zł' : '0.00 zł') : '0.00 zł'}</ControlLabel>
								</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Szerokość: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Szerokość"
								value={this.state.addObject.szerokosc}
								onChange={this.onAddZlecenieSzerokoscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Wysokość: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Wysokość"
								value={this.state.addObject.wysokosc}
								onChange={this.onAddZlecenieWysokoscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Grubość: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Grubość"
								value={this.state.addObject.grubosc}
								onChange={this.onAddZlecenieGruboscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Numer passparteau: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Numer passparteau"
								value={this.state.addObject.numerPass}
								onChange={this.onAddZlecenieNrPassChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Koszt usługi: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Koszt usługi"
								value={this.state.addObject.kosztUslugi}
								onChange={this.onAddZlecenieKosztUslugiChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Szkło: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<select className="form-control" id="szklo"
											value={this.state.addObject.szklo}
											onChange={this.onAddZlecenieSzkloChange} >
									<option>Wybierz typ</option>
			            <option>Zwykłe</option>
			            <option>Antyrefleks</option>
			            <option>Muzealne</option>
			          </select>
							</div>
						</div>

						<div className="row" style={{marginBottom: '6px'}}>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.hdf} onChange={this.onAddZlecenieHdfChange} /> HDF</label></div>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.zawieszka} onChange={this.onAddZlecenieZawieszkaChange} /> Zawieszka</label></div>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.lustro} onChange={this.onAddZlecenieLustroChange} /> Lustro</label></div>
						</div>
						<div className="row" style={{marginBottom: '6px'}}>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.czyPass} onChange={this.onAddZlecenieCzyPassChange} /> Passpartout</label></div>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.szlif} onChange={this.onAddZlecenieSzlifChange} /> Szlif (30/mb)</label></div>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.faza} onChange={this.onAddZlecenieFazaChange} /> Faza (50/mb)</label></div>
						</div>
						<div className="row" style={{marginBottom: '6px'}}>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.krosno} onChange={this.onAddZlecenieKrosnoChange} /> Krosno (35/mb)</label></div>
							<div className="col-sm-4"><label><input type="checkbox" checked={this.state.addObject.folia} onChange={this.onAddZlecenieFoliaChange} /> Folia (15/m²)</label></div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Ilość sztuk: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="number"
								min="1"
								placeholder="1"
								value={this.state.addObject.iloscSztuk}
								onChange={this.onAddZlecenieIloscSztukChange} />
							</div>
						</div>

<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Punkt sprzedaży: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<select className="form-control" id="punktSprzedazy"
											value={this.state.addObject.punktSprzedazy}
											onChange={this.onAddZleceniepunktSprzedazyChange} >
									<option>Wybierz punkt</option>
			            <option>Castorama</option>
			            <option>Arena</option>
			            <option>Domar</option>
			          </select>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Sprzedawca: </ControlLabel>
							</div>
							<div className="col-sm-8">
								<select className="form-control" id="punktSprzedazy"
											value={this.state.addObject.operator}
											onChange={this.onAddZlecenieOperatorChange} >
									<option>Wybierz sprzedawcę</option>
									<option>Jerzy</option>
									<option>Natalia</option>
									<option>Klara</option>
									<option>Klaudia</option>
									<option>Bartek</option>
								</select>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Uwagi: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Uwagi"
								rows="3"
								value={this.state.addObject.uwagi}
								onChange={this.onAddZlecenieUwagiChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Zaliczka: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Zaliczka"
								value={this.state.addObject.zaliczka}
								onChange={this.onAddZlecenieZaliczkaChange} />
							</div>
						</div>

				</Modal.Body>
				<Modal.Footer>
				<strong>Cena: {this.state.addObject.cena ? parseFloat(this.state.addObject.cena).toFixed(2) + ' zł' : '0.00 zł'}        </strong>
				<strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
					<Button onClick={this.props.parent.closeAddModal}>Zamknij</Button>
					<Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj</Button>
				</Modal.Footer>
			</Modal>
		);
	},

	clearAddObject: function() {
		this.state.addObject.id = '';
		this.state.addObject.imie = '';
		this.state.addObject.nazwisko = '';
		this.state.addObject.telefon = '';
		this.state.addObject.numerListwy = '';
		this.state.addObject.szerokosc = '';
		this.state.addObject.wysokosc = '';
		this.state.addObject.grubosc = '';
		this.state.addObject.cena = 0.00;
		this.state.addObject.numerPass = '';
		this.state.addObject.szklo = 'NIE';
		this.state.addObject.hdf = false;
		this.state.addObject.kosztUslugi = '';
		this.state.addObject.lustro = false;
		this.state.addObject.operator = '';
		this.state.addObject.uwagi = '';
		this.state.addObject.punktSprzedazy = '';
		this.state.addObject.zawieszka = false;
		this.state.addObject.dataZlozenia = '';
		this.state.addObject.czyZrealizowane = '';
		this.state.addObject.zaliczka = '';
		this.state.addObject.pozostalaDoplata = '',
		this.state.addObject.dataOdbioru = '',
		this.state.addObject.czyPass = false;
		this.state.addObject.email = '';
		this.state.addObject.nip = '';
		this.state.addObject.szlif = false;
		this.state.addObject.faza = false;
		this.state.addObject.krosno = false;
		this.state.addObject.folia = false;
		this.state.addObject.iloscSztuk = 1;
	},

	onAddZlecenieImieChange: function(event) {
		this.state.addObject.imie = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieNazwiskoChange: function(event) {
		this.state.addObject.nazwisko = event.target.value;
		this.fetchSuggestions(event.target.value, 'nazwisko');
		this.forceUpdate();
	},

	onAddZlecenieTelefonChange: function(event) {
		this.state.addObject.telefon = event.target.value;
		this.fetchSuggestions(event.target.value, 'telefon');
		this.forceUpdate();
	},

	fetchSuggestions: function(q, field) {
		var self = this;
		if (this.suggestTimeout) clearTimeout(this.suggestTimeout);
		var term = (q || '').trim();
		if (term.length < 2) {
			this.setState({ suggestions: [], activeSuggestField: null });
			return;
		}
		this.setState({ activeSuggestField: field });
		this.suggestTimeout = setTimeout(function() {
			axios.get(API_URL + '/klienci?q=' + encodeURIComponent(term))
				.then(function(res) {
					self.setState({ suggestions: res.data || [] });
				})
				.catch(function(err) { console.log(err); });
		}, 250);
	},

	onSuggestionClick: function(client) {
		this.state.addObject.imie = client.imie || '';
		this.state.addObject.nazwisko = client.nazwisko || '';
		this.state.addObject.telefon = client.telefon || '';
		this.state.addObject.email = client.email || '';
		this.state.addObject.nip = client.nip || '';
		this.setState({ suggestions: [], activeSuggestField: null });
	},

	hideSuggestions: function() {
		var self = this;
		setTimeout(function() {
			self.setState({ suggestions: [], activeSuggestField: null });
		}, 200);
	},

	renderSuggestions: function(field) {
		if (this.state.activeSuggestField !== field) return null;
		if (!this.state.suggestions || this.state.suggestions.length === 0) return null;
		var self = this;
		var style = {
			position: 'absolute',
			top: '100%',
			left: 0,
			right: 0,
			zIndex: 1000,
			background: '#fff',
			border: '1px solid #ccc',
			borderTop: 'none',
			maxHeight: '220px',
			overflowY: 'auto',
			boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
		};
		var itemStyle = { padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #eee' };
		return (
			<div style={style} onMouseDown={function(e) { e.preventDefault(); }}>
				{this.state.suggestions.map(function(s, i) {
					var line1 = (s.imie + ' ' + s.nazwisko).trim() || '(bez nazwiska)';
					var line2 = s.telefon + (s.email ? ' · ' + s.email : '');
					return (
						<div key={i}
							style={itemStyle}
							onMouseDown={function(e) { e.preventDefault(); self.onSuggestionClick(s); }}>
							<strong>{line1}</strong>
							<div style={{fontSize:'0.85em',color:'#666'}}>{line2}</div>
						</div>
					);
				})}
			</div>
		);
	},

	onAddZlecenieNrListwyChange: function(event) {
		this.state.addObject.numerListwy = event.target.value;

		this.dictListwa = this.getListwaByNrListwy(this.state.addObject.numerListwy);
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieNrPassChange: function(event) {
		this.state.addObject.numerPass = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieSzerokoscChange: function(event) {
		this.state.addObject.szerokosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},
	onAddZlecenieWysokoscChange: function(event) {
		this.state.addObject.wysokosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieGruboscChange: function(event) {
		this.state.addObject.grubosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieSzkloChange: function(event) {
		this.state.addObject.szklo = event.target.value;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieHdfChange: function(event) {
		this.state.addObject.hdf = !this.state.addObject.hdf;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieCzyPassChange: function(event) {
		this.state.addObject.czyPass = !this.state.addObject.czyPass;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieKosztUslugiChange: function(event) {
		this.state.addObject.kosztUslugi = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieLustroChange: function(event) {
		this.state.addObject.lustro = !this.state.addObject.lustro;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieOperatorChange: function(event) {
		this.state.addObject.operator = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieUwagiChange: function(event) {
		this.state.addObject.uwagi = event.target.value;
		this.forceUpdate();
	},

	onAddZleceniepunktSprzedazyChange: function(event) {
		this.state.addObject.punktSprzedazy = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieZawieszkaChange: function(event) {
		this.state.addObject.zawieszka = !this.state.addObject.zawieszka;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieEmailChange: function(event) {
		this.state.addObject.email = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieNipChange: function(event) {
		this.state.addObject.nip = event.target.value;
		this.forceUpdate();
	},

	onAddZlecenieSzlifChange: function(event) {
		this.state.addObject.szlif = !this.state.addObject.szlif;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieFazaChange: function(event) {
		this.state.addObject.faza = !this.state.addObject.faza;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieKrosnoChange: function(event) {
		this.state.addObject.krosno = !this.state.addObject.krosno;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieFoliaChange: function(event) {
		this.state.addObject.folia = !this.state.addObject.folia;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieIloscSztukChange: function(event) {
		this.state.addObject.iloscSztuk = parseInt(event.target.value) || 1;
		this.wyliczCene();
		this.forceUpdate();
	},

	onAddZlecenieZaliczkaChange: function(event) {
		this.state.addObject.zaliczka = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	wyliczCene: function() {
	var dlListwy = (parseFloat(parseFloat(this.state.addObject.wysokosc * 2) + parseFloat(this.state.addObject.szerokosc * 2)) + parseFloat(this.state.addObject.grubosc * 8)) / 100
	var kosztListwy = this.dictListwa ? (dlListwy * (this.dictListwa ? parseFloat(this.dictListwa.cenaZaMb) : 1)) : 0.00

	var kosztUslugi =  (this.state.addObject.kosztUslugi ? parseFloat(this.state.addObject.kosztUslugi) : 0.00)

	var pole = parseFloat((this.state.addObject.wysokosc / 100) * (this.state.addObject.szerokosc) / 100)
	
	var kosztSzkla = 0.00
	if (this.state.addObject.szklo && this.state.addObject.szklo == 'Zwykłe') kosztSzkla = parseFloat(80 * pole)
	if (this.state.addObject.szklo && this.state.addObject.szklo == 'Antyrefleks') kosztSzkla = parseFloat(120 * pole)
	if (this.state.addObject.szklo && this.state.addObject.szklo == 'Muzealne') kosztSzkla = parseFloat(600 * pole)
	var kosztPass = this.state.addObject.czyPass ? parseFloat(90 * pole) : 0.00
	var kostLustra = this.state.addObject.lustro ? parseFloat(200 * pole) : 0.00
	var kosztHdf =  this.state.addObject.hdf ?  parseFloat(78 * pole) : 0.00
	var kosztZawieszki = this.state.addObject.zawieszka ? parseFloat(3.10) : 0.00

	var kosztSzlifu = this.state.addObject.szlif ? parseFloat(30 * dlListwy) : 0.00;
	var kosztFazy = this.state.addObject.faza ? parseFloat(50 * dlListwy) : 0.00;
	var kosztKrosna = this.state.addObject.krosno ? parseFloat(35 * dlListwy) : 0.00;
	var kosztFolii = this.state.addObject.folia ? parseFloat(15 * pole) : 0.00;

	kosztListwy = (isNaN(kosztListwy) ? 0.00 : kosztListwy);
	kosztUslugi = (isNaN(kosztUslugi) ? 0.00 : kosztUslugi);
	kosztSzkla = (isNaN(kosztSzkla) ? 0.00 : kosztSzkla);
    kosztPass = (isNaN(kosztPass) ? 0.00 : kosztPass);
	kostLustra = (isNaN(kostLustra) ? 0.00 : kostLustra);
	kosztHdf = (isNaN(kosztHdf) ? 0.00 : kosztHdf);
	kosztZawieszki = (isNaN(kosztZawieszki) ? 0.00 : kosztZawieszki);
	kosztSzlifu = (isNaN(kosztSzlifu) ? 0.00 : kosztSzlifu);
	kosztFazy = (isNaN(kosztFazy) ? 0.00 : kosztFazy);
	kosztKrosna = (isNaN(kosztKrosna) ? 0.00 : kosztKrosna);
	kosztFolii = (isNaN(kosztFolii) ? 0.00 : kosztFolii);

	if (this.state.addObject.szklo == 'false') this.state.addObject.szklo = 'NIE'
	if (this.state.addObject.szklo == 'Wybierz typ' || this.state.addObject.szklo == 'NIE') kosztSzkla = 0.00
	var cenaJednostkowa = parseFloat(kosztListwy + kosztUslugi + kosztSzkla + kosztPass + kostLustra + kosztHdf + kosztZawieszki + kosztSzlifu + kosztFazy + kosztKrosna + kosztFolii);
	var iloscSztuk = parseInt(this.state.addObject.iloscSztuk) || 1;
	this.state.addObject.cena = cenaJednostkowa * iloscSztuk;

		this.forceUpdate();
	},

	getDictListwy: function() {
		axios.get(API_URL + '/dictListwy')
		.then(function (dictListwa) {
			this.setState({dataDictListwy: dictListwa.data});
		}.bind(this));
	},

	getListwaByNrListwy: function(numerListwy) {
		for(var i in this.state.dataDictListwy) {
			if(this.state.dataDictListwy[i].numerListwy == numerListwy) {
				return this.state.dataDictListwy[i];
			}
		}
		return 'brak';
	},

	onAddBtnClicked: function() {
		axios.post(API_URL + '/zlecenie/', this.state.addObject)
			.then(function (response) {
				this.props.parent.closeAddModal();
				this.props.parent.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błędnie wprowadzone dane");
				console.log(error);
			});
	}
});

export default AddZlecenie;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/AddZlecenie.js